import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import { IStoryWithContent } from '@opengov/stories-shared/types';
import cx from 'classnames2';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-css';
import React from 'react';

import { IPublicationCustomCssMessages } from '../../../../../types';
import { CodeEditor } from '../../../../common/components/CodeEditor';

import styles from './CustomCodeBlock.scss';

export interface ICustomCodeBlockProps {
  messages: IPublicationCustomCssMessages;
  publicationCss: string;
  publicationCodeEditorRef: React.RefObject<CodeEditor>;
  story: IStoryWithContent | null;
  storyCss: string;
  storyCodeEditorRef: React.RefObject<CodeEditor>;
  isEditingGlobalCss: boolean;
  setIsEditingGlobalCss(isEditingGlobalCss: boolean): void;
  onPublicationCssChange(publicationCss: string): void;
  onStoryCssChange(storyCss: string): void;
}

const commonEditorProps = {
  showCopyControl: true,
  showUndoRedoControls: true,
  highlight: (code) => highlight(code, languages.css),
  padding: 12
};

export const CustomCodeBlock = (props: ICustomCodeBlockProps) => {
  const {
    messages,
    publicationCss,
    publicationCodeEditorRef,
    story,
    storyCss,
    storyCodeEditorRef,
    isEditingGlobalCss,
    setIsEditingGlobalCss,
    onPublicationCssChange,
    onStoryCssChange
  } = props;

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <Typography variant="h4">{messages.customCssStyling}</Typography>
        <Typography variant="body2" color="text.secondary">{messages.customCssHint}</Typography>
      </div>
      <Tabs
        value={isEditingGlobalCss ? 1 : 0}
        data-test="customCodeTabs"
      >
        <Tab label={messages.currentStory} data-test="currentStoryTab" onClick={() => setIsEditingGlobalCss(false)} />
        <Tab label={messages.publication} data-test="publicationTab" onClick={() => setIsEditingGlobalCss(true)} />
      </Tabs>
      <div className={styles.editorWrapper}>
        <CodeEditor
          {...commonEditorProps}
          ref={storyCodeEditorRef}
          dataTest="storyCodeEditor"
          wrapperClassName={cx(styles.editor, { [styles.editorHidden]: isEditingGlobalCss })}
          value={storyCss}
          onValueChange={onStoryCssChange}
          disabled={!story}
        />
        <CodeEditor
          {...commonEditorProps}
          ref={publicationCodeEditorRef}
          dataTest="publicationCodeEditor"
          wrapperClassName={cx(styles.editor, { [styles.editorHidden]: !isEditingGlobalCss })}
          value={publicationCss}
          onValueChange={onPublicationCssChange}
          disabled={!story}
        />
      </div>
    </div>
  );
};
